
import Dexie, { Table } from 'dexie';
export interface PdfResponse {
  id?: number;
  data: Uint8Array[];
  image: string;
}

export class DbServiceService extends Dexie {
  pdfs!: Table<PdfResponse, number>;
  constructor() {
    super('upcareer');
    this.version(1).stores({
      pdfs: '++id,data,image',
    });
  }
}
export const db = new DbServiceService();


